"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckboxHandler = exports.PresentationalCheckboxGroup = exports.CheckboxGroup = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireWildcard(require("react"));
var _useObservabilitySafe = require("../../../hooks/useObservabilitySafe");
var _index = require("../../index");
var _CheckboxOrRadio = require("../CheckboxOrRadio");
var _excluded = ["options", "selectedValues", "onClick", "disabled", "errorMessage", "hasContainer", "name", "analyticsName", "trackImpression", "aria-label", "aria-labelledby"],
  _excluded2 = ["value"],
  _excluded3 = ["value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_14ey1xykuo() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/Checkbox/CheckboxGroup.tsx";
  var hash = "3ecb3f6f8e75af9b7a433cbcc03af721b3f98947";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/Checkbox/CheckboxGroup.tsx",
    statementMap: {
      "0": {
        start: {
          line: 63,
          column: 87
        },
        end: {
          line: 137,
          column: 1
        }
      },
      "1": {
        start: {
          line: 77,
          column: 20
        },
        end: {
          line: 77,
          column: 96
        }
      },
      "2": {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 103,
          column: 3
        }
      },
      "3": {
        start: {
          line: 80,
          column: 38
        },
        end: {
          line: 80,
          column: 48
        }
      },
      "4": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 102,
          column: 6
        }
      },
      "5": {
        start: {
          line: 92,
          column: 48
        },
        end: {
          line: 92,
          column: 62
        }
      },
      "6": {
        start: {
          line: 105,
          column: 2
        },
        end: {
          line: 136,
          column: 4
        }
      },
      "7": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 128,
          column: 10
        }
      },
      "8": {
        start: {
          line: 125,
          column: 48
        },
        end: {
          line: 125,
          column: 62
        }
      },
      "9": {
        start: {
          line: 145,
          column: 34
        },
        end: {
          line: 159,
          column: 1
        }
      },
      "10": {
        start: {
          line: 149,
          column: 44
        },
        end: {
          line: 149,
          column: 73
        }
      },
      "11": {
        start: {
          line: 150,
          column: 22
        },
        end: {
          line: 157,
          column: 3
        }
      },
      "12": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 155,
          column: 6
        }
      },
      "13": {
        start: {
          line: 153,
          column: 40
        },
        end: {
          line: 153,
          column: 53
        }
      },
      "14": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 156,
          column: 45
        }
      },
      "15": {
        start: {
          line: 158,
          column: 2
        },
        end: {
          line: 158,
          column: 40
        }
      },
      "16": {
        start: {
          line: 165,
          column: 59
        },
        end: {
          line: 170,
          column: 1
        }
      },
      "17": {
        start: {
          line: 166,
          column: 41
        },
        end: {
          line: 166,
          column: 61
        }
      },
      "18": {
        start: {
          line: 167,
          column: 2
        },
        end: {
          line: 169,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 63,
            column: 87
          },
          end: {
            line: 63,
            column: 88
          }
        },
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 137,
            column: 1
          }
        },
        line: 76
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 92,
            column: 42
          },
          end: {
            line: 92,
            column: 43
          }
        },
        loc: {
          start: {
            line: 92,
            column: 48
          },
          end: {
            line: 92,
            column: 62
          }
        },
        line: 92
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 115,
            column: 19
          },
          end: {
            line: 115,
            column: 20
          }
        },
        loc: {
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 128,
            column: 10
          }
        },
        line: 116
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 125,
            column: 42
          },
          end: {
            line: 125,
            column: 43
          }
        },
        loc: {
          start: {
            line: 125,
            column: 48
          },
          end: {
            line: 125,
            column: 62
          }
        },
        line: 125
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 145,
            column: 34
          },
          end: {
            line: 145,
            column: 35
          }
        },
        loc: {
          start: {
            line: 148,
            column: 5
          },
          end: {
            line: 159,
            column: 1
          }
        },
        line: 148
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 147,
            column: 66
          },
          end: {
            line: 147,
            column: 67
          }
        },
        loc: {
          start: {
            line: 147,
            column: 72
          },
          end: {
            line: 147,
            column: 74
          }
        },
        line: 147
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 150,
            column: 22
          },
          end: {
            line: 150,
            column: 23
          }
        },
        loc: {
          start: {
            line: 150,
            column: 41
          },
          end: {
            line: 157,
            column: 3
          }
        },
        line: 150
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 153,
            column: 31
          },
          end: {
            line: 153,
            column: 32
          }
        },
        loc: {
          start: {
            line: 153,
            column: 40
          },
          end: {
            line: 153,
            column: 53
          }
        },
        line: 153
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 165,
            column: 59
          },
          end: {
            line: 165,
            column: 60
          }
        },
        loc: {
          start: {
            line: 165,
            column: 70
          },
          end: {
            line: 170,
            column: 1
          }
        },
        line: 165
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 65,
            column: 19
          },
          end: {
            line: 65,
            column: 21
          }
        }],
        line: 65
      },
      "1": {
        loc: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 79
      },
      "2": {
        loc: {
          start: {
            line: 92,
            column: 19
          },
          end: {
            line: 92,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 30
          },
          end: {
            line: 92,
            column: 39
          }
        }, {
          start: {
            line: 92,
            column: 42
          },
          end: {
            line: 92,
            column: 62
          }
        }],
        line: 92
      },
      "3": {
        loc: {
          start: {
            line: 96,
            column: 9
          },
          end: {
            line: 100,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 97,
            column: 10
          },
          end: {
            line: 99,
            column: 17
          }
        }, {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 100,
            column: 16
          }
        }],
        line: 96
      },
      "4": {
        loc: {
          start: {
            line: 125,
            column: 19
          },
          end: {
            line: 125,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 30
          },
          end: {
            line: 125,
            column: 39
          }
        }, {
          start: {
            line: 125,
            column: 42
          },
          end: {
            line: 125,
            column: 62
          }
        }],
        line: 125
      },
      "5": {
        loc: {
          start: {
            line: 130,
            column: 7
          },
          end: {
            line: 134,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 133,
            column: 15
          }
        }, {
          start: {
            line: 134,
            column: 10
          },
          end: {
            line: 134,
            column: 14
          }
        }],
        line: 130
      },
      "6": {
        loc: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 35
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 146,
            column: 33
          },
          end: {
            line: 146,
            column: 35
          }
        }],
        line: 146
      },
      "7": {
        loc: {
          start: {
            line: 147,
            column: 2
          },
          end: {
            line: 147,
            column: 74
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 147,
            column: 66
          },
          end: {
            line: 147,
            column: 74
          }
        }],
        line: 147
      },
      "8": {
        loc: {
          start: {
            line: 149,
            column: 53
          },
          end: {
            line: 149,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 53
          },
          end: {
            line: 149,
            column: 66
          }
        }, {
          start: {
            line: 149,
            column: 70
          },
          end: {
            line: 149,
            column: 72
          }
        }],
        line: 149
      },
      "9": {
        loc: {
          start: {
            line: 152,
            column: 6
          },
          end: {
            line: 154,
            column: 35
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 153,
            column: 10
          },
          end: {
            line: 153,
            column: 54
          }
        }, {
          start: {
            line: 154,
            column: 10
          },
          end: {
            line: 154,
            column: 35
          }
        }],
        line: 152
      },
      "10": {
        loc: {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 156,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 156,
            column: 11
          }
        }, {
          start: {
            line: 156,
            column: 15
          },
          end: {
            line: 156,
            column: 44
          }
        }],
        line: 156
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3ecb3f6f8e75af9b7a433cbcc03af721b3f98947"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_14ey1xykuo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_14ey1xykuo();
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * INSTRUCTIONS FOR CHECKBOX GROUP:
 * There are two types of components for checkbox group:
 *   option 1) Presentational checkbox group that is just there for design. Consumers must handle keeping track of checked values, creating & passing in a custom onClick handler
 *   option 2) A stateful checkbox group that handles default logic for the consumer and keeps track of checked values
 *   Please choose the one that is best suited for your needs
 */
/** onClick & selectedValues are required for PresentationalCheckboxGroup */
/**
 * OPTION 1: PRESENTATIONAL CHECKBOX GROUP
 *   This checkbox group is purely presentational
 *   This checkbox group does not keep track of selected values and does not have default handleClick. Consumer must handle and create these themselves.
 *   If you would like the bricks checkbox group to handle this please use CheckboxGroup which is a combination of PresentationalCheckboxGroup & a hook with default checkbox logic
 */
cov_14ey1xykuo().s[0]++;
var PresentationalCheckboxGroup = exports.PresentationalCheckboxGroup = function PresentationalCheckboxGroup(_ref) {
  var options = _ref.options,
    _ref$selectedValues = _ref.selectedValues,
    selectedValues = _ref$selectedValues === void 0 ? (cov_14ey1xykuo().b[0][0]++, []) : _ref$selectedValues,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    hasContainer = _ref.hasContainer,
    name = _ref.name,
    analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    ariaLabel = _ref['aria-label'],
    ariaLabelBy = _ref['aria-labelledby'],
    props = _objectWithoutProperties(_ref, _excluded);
  cov_14ey1xykuo().f[0]++;
  var inViewRef = (cov_14ey1xykuo().s[1]++, (0, _useObservabilitySafe.useTrackComponentInView)('checkboxViewEvent', trackImpression, analyticsName));
  cov_14ey1xykuo().s[2]++;
  if (options.length === 1) {
    cov_14ey1xykuo().b[1][0]++;
    var _ref2 = (cov_14ey1xykuo().s[3]++, options[0]),
      _value = _ref2.value,
      optionProps = _objectWithoutProperties(_ref2, _excluded2);
    cov_14ey1xykuo().s[4]++;
    return /*#__PURE__*/_react["default"].createElement(_index.Flex, {
      ref: inViewRef,
      flexDirection: "column"
    }, /*#__PURE__*/_react["default"].createElement(_CheckboxOrRadio.Checkbox, _extends({
      analyticsName: analyticsName,
      checked: selectedValues.includes(_value),
      disabled: disabled,
      errorMessage: errorMessage,
      hasContainer: hasContainer,
      key: _value,
      name: name,
      value: _value,
      onClick: disabled ? (cov_14ey1xykuo().b[2][0]++, undefined) : (cov_14ey1xykuo().b[2][1]++, function () {
        cov_14ey1xykuo().f[1]++;
        cov_14ey1xykuo().s[5]++;
        return onClick(_value);
      })
    }, optionProps, props)), errorMessage !== undefined ? (cov_14ey1xykuo().b[3][0]++, /*#__PURE__*/_react["default"].createElement(_index.Text, {
      color: "red50",
      fontSize: "s1",
      "data-testid": 'error messaging'
    }, errorMessage)) : (cov_14ey1xykuo().b[3][1]++, null));
  } else {
    cov_14ey1xykuo().b[1][1]++;
  }
  cov_14ey1xykuo().s[6]++;
  return (
    /*#__PURE__*/
    // Identifies the div element as a group container for the checkboxes.
    // https://www.w3.org/TR/wai-aria-practices-1.1/examples/checkbox/checkbox-1/checkbox-1.html
    _react["default"].createElement(_index.Flex, {
      ref: inViewRef,
      flexDirection: "column",
      role: "group",
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelBy
    }, options.map(function (_ref3) {
      var value = _ref3.value,
        optionProps = _objectWithoutProperties(_ref3, _excluded3);
      cov_14ey1xykuo().f[2]++;
      cov_14ey1xykuo().s[7]++;
      return /*#__PURE__*/_react["default"].createElement(_CheckboxOrRadio.Checkbox, _extends({
        analyticsName: analyticsName,
        checked: selectedValues.includes(value),
        disabled: disabled,
        errorMessage: errorMessage,
        hasContainer: hasContainer,
        key: value,
        name: name,
        value: value,
        onClick: disabled ? (cov_14ey1xykuo().b[4][0]++, undefined) : (cov_14ey1xykuo().b[4][1]++, function () {
          cov_14ey1xykuo().f[3]++;
          cov_14ey1xykuo().s[8]++;
          return onClick(value);
        })
      }, optionProps, props));
    }), errorMessage !== undefined ? (cov_14ey1xykuo().b[5][0]++, /*#__PURE__*/_react["default"].createElement(_index.Text, {
      color: "red50",
      fontSize: "s1",
      "data-testid": 'error messaging'
    }, errorMessage)) : (cov_14ey1xykuo().b[5][1]++, null))
  );
};

/**
 * NOTE: This is a hook that handles keeping track of selected values & the handleClick
 * Please use useCheckboxHandler hook if you want to
 *  1) use default checkbox handling logic like something that checks & unchecks a checkbox
 *  2) have the bricks component keep track of checked values
 */
cov_14ey1xykuo().s[9]++;
var useCheckboxHandler = exports.useCheckboxHandler = function useCheckboxHandler() {
  var _ref6;
  var initialValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_14ey1xykuo().b[6][0]++, []);
  var onClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_14ey1xykuo().b[7][0]++, function () {
    cov_14ey1xykuo().f[5]++;
  });
  cov_14ey1xykuo().f[4]++;
  var _ref4 = (cov_14ey1xykuo().s[10]++, (0, _react.useState)((_ref6 = (cov_14ey1xykuo().b[8][0]++, initialValues)) !== null && _ref6 !== void 0 ? _ref6 : (cov_14ey1xykuo().b[8][1]++, []))),
    _ref5 = _slicedToArray(_ref4, 2),
    checkedValues = _ref5[0],
    setCheckedValues = _ref5[1];
  cov_14ey1xykuo().s[11]++;
  var handleClick = function handleClick(value) {
    cov_14ey1xykuo().f[6]++;
    cov_14ey1xykuo().s[12]++;
    setCheckedValues(checkedValues.includes(value) ? (cov_14ey1xykuo().b[9][0]++, checkedValues.filter(function (val) {
      cov_14ey1xykuo().f[7]++;
      cov_14ey1xykuo().s[13]++;
      return val !== value;
    })) : (cov_14ey1xykuo().b[9][1]++, [].concat(_toConsumableArray(checkedValues), [value])));
    cov_14ey1xykuo().s[14]++;
    (cov_14ey1xykuo().b[10][0]++, onClick) && (cov_14ey1xykuo().b[10][1]++, onClick(checkedValues, value));
  };
  cov_14ey1xykuo().s[15]++;
  return {
    checkedValues: checkedValues,
    handleClick: handleClick
  };
};

/**
 * OPTION 2: STATEFUL CHECKBOX GROUP: A stateful checkbox group that handles all the default logic for the consumer
 *   This checkbox group keeps track of selected values & has a handleClick that handles logic like checking & unchecking a checkbox
 */
cov_14ey1xykuo().s[16]++;
var CheckboxGroup = exports.CheckboxGroup = function CheckboxGroup(props) {
  cov_14ey1xykuo().f[8]++;
  var _ref7 = (cov_14ey1xykuo().s[17]++, useCheckboxHandler()),
    checkedValues = _ref7.checkedValues,
    handleClick = _ref7.handleClick;
  cov_14ey1xykuo().s[18]++;
  return /*#__PURE__*/_react["default"].createElement(PresentationalCheckboxGroup, _extends({
    selectedValues: checkedValues,
    onClick: handleClick
  }, props));
};